import type { ZodIssue } from "zod";

export const formatZodErrors = (errors: ZodIssue[]): string => {
	return errors
		.map((err) => {
			const [...fieldPath] = err.path;
			const field = fieldPath.at(-1);
			let expectedMsg = "";
			if (
				typeof err === "object" &&
				err != null &&
				"expected" in err &&
				"received" in err
			) {
				const expected = (err as { expected: unknown }).expected;
				const received = (err as { received: unknown }).received;
				expectedMsg = ` (expected ${String(expected)}, received ${String(received)})`;
			}
			return `❌ Field: ${field}, Error: ${err.message}, Descriptor: ${expectedMsg}`;
		})
		.join("\n");
};
